module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1"
  }, [_vm._v("DEDICATION")]), _vm._v(" "), _c('p', {
    staticClass: "s-txt"
  }, [_vm._v("We dedicate this book to our mothers, fathers, grandmothers, and grandfathers, whose creativity, resourcefulness, and love of all things handmade inspired us to learn to sew.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7505ae4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/04_dedication.vue
// module id = 63
// module chunks = 0